module.exports = __webpack_public_path__ + "static/media/cover.f07a42df.jpg";